const BlogNewsletter = () => {
  return (
    <section
      className="relative overflow-hidden text-white flex flex-col md:flex-row justify-between items-start md:items-center gap-[27px] md:gap-[45px] mx-4 md:mx-auto mb-[65px] md:mb-[88px] px-[26px] py-[35px] md:px-[48px] md:py-[43px]"
      style={{
        background: "#201d18",
        borderRadius: "22px",
        maxWidth: "1228px",
        minHeight: "245px",
      }}
    >
      <span
        aria-hidden="true"
        className="absolute pointer-events-none select-none"
        style={{
          bottom: "-46px",
          right: "-8px",
          color: "#ffffff0b",
          fontFamily: "Georgia, serif",
          fontSize: "130px",
          fontWeight: 700,
        }}
      >
        READ
      </span>

      <div className="relative z-[1]">
        <p
          className="text-secondary"
          style={{
            letterSpacing: "0.1em",
            margin: "0 0 8px",
            fontSize: "15px",
            fontWeight: 800,
          }}
        >
          THE USEFUL UPDATE
        </p>
        <h2
          style={{
            letterSpacing: "-0.04em",
            maxWidth: "730px",
            margin: 0,
            fontFamily: "Georgia, serif",
            fontSize: "clamp(32px, 3.7vw, 48px)",
            fontWeight: 500,
            lineHeight: 1.12,
          }}
        >
          Ideas worth carrying into your next decision.
        </h2>
        <span
          className="block"
          style={{
            color: "#d6d2ca",
            marginTop: "13px",
            fontSize: "16px",
            lineHeight: 1.6,
          }}
        >
          Get selected Utiva stories, events and practical learning updates in
          your inbox.
        </span>
      </div>

      <a
        href="mailto:info@utiva.io?subject=Add%20me%20to%20the%20Utiva%20Journal%20updates"
        className="relative z-[1] flex-none inline-flex items-center text-primary bg-secondary"
        style={{
          borderRadius: "9px",
          gap: "10px",
          minHeight: "52px",
          padding: "13px 18px",
          fontSize: "15px",
          fontWeight: 800,
        }}
      >
        Join the journal list <span aria-hidden="true">→</span>
      </a>
    </section>
  );
};

export default BlogNewsletter;
